import { Link } from "react-router-dom";
import { LOGO_URL } from "@/lib/api";
import { MapPin, Phone, Mail } from "lucide-react";

export const Footer = () => (
  <footer className="bg-slate-900 text-slate-300 mt-24">
    <div className="max-w-7xl mx-auto px-6 py-16 grid gap-10 md:grid-cols-4">
      <div className="md:col-span-2">
        <div className="flex items-center gap-3 mb-4">
          <img src={LOGO_URL} alt="LBM" className="h-12 w-12 rounded-full object-contain bg-white ring-2 ring-secondary p-0.5" />
          <div className="font-heading font-extrabold text-white text-lg">London Boy Movement</div>
        </div>
        <p className="text-sm text-slate-400 max-w-md leading-relaxed">
          The central command engine of a statewide grassroots mobilisation advancing the vision of
          Sen. Ahmed Aliyu Wadada across all 13 LGAs of Nasarawa State.
        </p>
      </div>
      <div>
        <h4 className="font-heading font-bold text-white mb-4 text-base">Quick Links</h4>
        <ul className="space-y-2 text-sm">
          <li><Link to="/structure" className="hover:text-secondary transition-colors">Find your Coordinator</Link></li>
          <li><Link to="/volunteer" className="hover:text-secondary transition-colors">Join the Movement</Link></li>
          <li><Link to="/media" className="hover:text-secondary transition-colors">Media & Press</Link></li>
          <li><Link to="/admin/login" className="hover:text-secondary transition-colors">Admin Login</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="font-heading font-bold text-white mb-4 text-base">Contact</h4>
        <ul className="space-y-3 text-sm text-slate-400">
          <li className="flex items-center gap-2"><MapPin className="w-4 h-4 text-secondary" /> Lafia, Nasarawa State</li>
          <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-secondary" /> +234 803 000 0000</li>
          <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-secondary" /> info@londonboymovement.ng</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-slate-800 py-6 text-center text-xs text-slate-500">
      © {new Date().getFullYear()} London Boy Movement, Nasarawa State. All rights reserved.
    </div>
  </footer>
);
